export const faqItems = [
  {
    question: '蜜桃视频上的内容都是免费观看的吗？',
    answer: '是的，蜜桃视频平台上的所有内容均可免费观看。我们致力于为用户提供优质的免费高清视频内容，涵盖生活、娱乐、美食、旅行等多个类目，无需付费即可畅享全部资源。',
  },
  {
    question: '蜜桃视频支持哪些设备观看？',
    answer: '蜜桃视频全面支持PC端、平板和手机端观看，适配主流浏览器。无论您使用Chrome、Safari、Edge还是Firefox，都能获得流畅的观看体验。我们采用自适应码率技术，根据您的网络状况自动调整画质。',
  },
  {
    question: '视频的画质怎么样？支持高清播放吗？',
    answer: '蜜桃视频所有内容均支持高清播放，最高可达4K超清画质。我们采用领先的视频编码技术，在保证画质的同时优化加载速度，让您畅享流畅的高清观影体验。',
  },
  {
    question: '如何找到我感兴趣的视频内容？',
    answer: '您可以通过首页的分类导航浏览不同类目的视频，也可以使用页面顶部的搜索功能直接搜索关键词。我们的智能推荐系统还会根据您的观看偏好，为您推荐个性化内容。',
  },
  {
    question: '蜜桃视频可以下载离线观看吗？',
    answer: '目前蜜桃视频支持在App端下载视频进行离线观看。网页版暂不提供下载功能，但您可以通过收藏功能保存喜欢的视频，随时回来观看。',
  },
  {
    question: '如何成为蜜桃视频的内容创作者？',
    answer: '我们欢迎优质内容创作者入驻蜜桃视频平台！您可以通过「关于我们」页面的联系方式提交申请，我们的内容团队会在3个工作日内审核并回复您的申请。',
  },
];

export const aboutFaqItems = [
  {
    question: '蜜桃视频是什么时候成立的？',
    answer: '蜜桃视频成立于2024年，是一家专注于精选高清视频内容的聚合平台。我们致力于为用户提供高品质、多元化的视频内容体验。',
  },
  {
    question: '蜜桃视频的内容来源是什么？',
    answer: '蜜桃视频的内容来自精心筛选的优质创作者和专业内容制作团队。每一部视频都经过严格的审核流程，确保内容质量和观看体验。',
  },
  {
    question: '蜜桃视频如何保证内容质量？',
    answer: '我们建立了完善的内容审核机制，从选题策划、拍摄制作到后期剪辑，每个环节都有专业团队把关。同时我们也会根据用户反馈不断优化内容质量。',
  },
];

export const brandMilestones = [
  { year: '2024年', title: '品牌创立', description: '蜜桃视频正式上线，以"精选高清视频"为核心理念，开启优质内容聚合之旅。' },
  { year: '2024年Q3', title: '用户突破100万', description: '凭借优质内容和流畅体验，蜜桃视频在上线半年内迅速积累百万用户。' },
  { year: '2025年', title: '内容全面升级', description: '拓展至生活、娱乐、美食、旅行、科技、时尚六大核心类目，构建完整的内容生态。' },
  { year: '2025年Q4', title: '用户突破500万', description: '成为华语地区最受欢迎的视频内容平台之一，日均活跃用户超过50万。' },
  { year: '2026年', title: '技术革新', description: '全面升级视频编码技术，支持4K超清播放和AI智能推荐，为用户带来更好的观看体验。' },
];

export const testimonials = [
  {
    name: '陈先生',
    role: '资深用户',
    avatar: 'C',
    content: '蜜桃视频的画质真的很棒，比很多平台都清晰。而且分类很细致，找视频特别方便，已经推荐给身边所有朋友了！',
    rating: 5,
  },
  {
    name: '林小姐',
    role: '美食博主',
    avatar: 'L',
    content: '作为一个美食内容创作者，蜜桃视频给了我很好的展示平台。审核快、流量好，创作环境非常友好。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '大学生',
    avatar: 'W',
    content: '每天睡前必刷蜜桃视频！内容质量很高，不像其他平台那么多低质内容。特别是旅行类视频，简直是精神食粮。',
    rating: 5,
  },
  {
    name: '张女士',
    role: '时尚爱好者',
    avatar: 'Z',
    content: '蜜桃视频的时尚穿搭内容太实用了！学到了好多搭配技巧，而且视频节奏刚刚好，不拖沓，每一分钟都是干货。',
    rating: 4,
  },
  {
    name: '刘先生',
    role: '科技发烧友',
    avatar: 'L',
    content: '科技评测类视频做得非常专业，对比数据详细、观点中立。是我目前最信任的数码产品评测渠道之一。',
    rating: 5,
  },
  {
    name: '赵女士',
    role: '全职妈妈',
    avatar: 'Z',
    content: '生活类和美食类内容太适合我了！跟着视频学做了好多新菜，家居改造的灵感也全来自蜜桃视频。',
    rating: 5,
  },
];